<template>
<div class="third-question">
	<grid>
		<grid-item size="1/1">
			<h2 class="question-text">{{ question.text }}</h2>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="1/1" class="response">
			<div class="items">
				<label v-for="(resItem, resIndex) in question.responses" :key="resIndex"
					:class="{ active: response.includes(resIndex) }">
					<input hidden type="checkbox"
						:value="resIndex"
						:name="'item'"
						v-model="checkItems"
						:disabled="checkItems.length >= 5 && !response.includes(resIndex)"
					/>
					<span>
						{{ resItem.text }}
					</span>
				</label>
			</div>
		</grid-item>
	</grid>
</div>
</template>

<script>
export default {
	props: [
		'value',
		'question'
	],
	data: () => ({
		checkItems: []
	}),
	computed: {
		response: {
			get() {
				return this.value == null ? [] : this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		}
	},
	watch: {
		checkItems(event) {
			this.response = event
		}
	}
}
</script>

<style lang="scss">
.third-question {
	label {
		color: #999999 !important;
		border: 1px solid #8a8c91;
		padding: 4px 13px;
		float: left;
		margin: 0 6px 6px 0;
		border-radius: 30px;

		&:hover {
			font-weight: 400 !important;
		}

		span {
			font-size: 11px;
			text-transform: uppercase;
			user-select: none;
			position: relative;
			bottom: 2px;
		}
	}
	label.active {
		background: #42464d !important;
		border-color: #42464d !important;
		color: #999999 !important;

		&:hover {
			background: #42464d !important;
			border-color: #42464d !important;
			color: #999999 !important;
		}
	}
	.response {
		background: #eceae2;
		padding: 15px 6px 15px 15px !important;
		height: 200px;

		.items {
			height: 170px;
			overflow: hidden;
			overflow-y: scroll;
		}
	}
	.items::-webkit-scrollbar {
		width: 9px;
	}
	.items::-webkit-scrollbar-thumb {
		border: 4px solid rgba(0, 0, 0, 0);
		background-clip: padding-box;
		background-color: #4ba98b;
	}
}
</style>
